// Only these lodash functions are exported, which keeps about 500 kB out of the bundle; add one only if it pays off.

export type { Dictionary } from 'lodash';
export { default as cloneDeep } from 'lodash/cloneDeep';
export { default as countBy } from 'lodash/countBy';
export { default as debounce } from 'lodash/debounce';
export { default as difference } from 'lodash/difference';
export { default as escapeRegExp } from 'lodash/escapeRegExp';
export { default as get } from 'lodash/get';
export { default as groupBy } from 'lodash/groupBy';
export { default as inRange } from 'lodash/inRange';
export { default as intersection } from 'lodash/intersection';
export { default as keyBy } from 'lodash/keyBy';
export { default as mapValues } from 'lodash/mapValues';
export { default as maxBy } from 'lodash/maxBy';
export { default as memoize } from 'lodash/memoize';
export { default as minBy } from 'lodash/minBy';
export { default as omit } from 'lodash/omit';
export { default as pick } from 'lodash/pick';
export { default as pickBy } from 'lodash/pickBy';
export { default as range } from 'lodash/range';
export { default as shuffle } from 'lodash/shuffle';
export { default as sortBy } from 'lodash/sortBy';
export { default as sumBy } from 'lodash/sumBy';
export { default as times } from 'lodash/times';
export { default as uniq } from 'lodash/uniq';
export { default as uniqBy } from 'lodash/uniqBy';
export { default as uniqueId } from 'lodash/uniqueId';
export { default as uniqWith } from 'lodash/uniqWith';
